module.exports = __webpack_public_path__ + "static/media/star_active.ef06c9dc.svg";